module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tAbout Webkey\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), _c('v-layout', {
    staticClass: "modal__section",
    attrs: {
      "align-space-around": "",
      "justify-center": "",
      "column": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Version: " + _vm._s(_vm.versionCode))]), _vm._v(" "), _c('p', [_vm._v("Copyright © Webkey Development Kft. " + _vm._s(new Date().getFullYear()))]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "unmarked",
    attrs: {
      "href": "/terms/",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" • "), _c('a', {
    staticClass: "unmarked",
    attrs: {
      "href": "/privacy-policy/",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c93d9a02","hasScoped":false}!./app/components/account-about-modal/template.html
// module id = 398
// module chunks = 0